<template>
  <div
    class="font-normal text-gray-800"
  >
    <div
      class="flex justify-between px-8 py-1 text-lg text-white rounded-t-lg bg-purple-mobly"
    >
      <p
        class="font-semibold"
      >
        Detalhes do Pedido: {{ order.orderNr }}
      </p>

      <div
        class="items-center hidden space-x-4 md:flex"
      >
        <p>
          Realizado em: {{ order.date }}
        </p>
      </div>
    </div>

    <div
      class="items-center px-8 pb-3 space-y-3 bg-white border border-gray-200 rounded-b-lg shadow-md"
    >
      <p
        class="block w-full mt-3 md:hidden"
      >
        Realizado em: {{ order.date }}
      </p>

      <p
        class="w-full text-xl font-semibold"
        :class="orderLabels[orderStatus].textColor"
      >
        {{ orderLabels[orderStatus].title }}
      </p>

      <div class="justify-between block space-y-5 md:space-y-0 md:space-x-4 md:flex">
        <div
          class="flex flex-wrap content-betweenw-min whitespace-nowrap"
        >
          <div
            class="w-full"
          >
            <div
              class="flex justify-between w-full items-cente"
              @click="toggleShowClientData = !toggleShowClientData"
            >
              <div
                class="flex items-cent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6 text-purple-mobly"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path fill-rule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clip-rule="evenodd" />
                </svg>

                <span
                  class="text-lg font-semibold"
                >
                  Dados do Titular
                </span>
              </div>

              <div
                class="block md:hidden"
              >
                <svg
                  v-if="!toggleShowClientData"
                  xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>

                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                  />
                </svg>
              </div>
            </div>

            <div
              class="pl-4 md:grid"
              :class="toggleShowClientData ? 'grid' : 'hidden'"
            >
              <span>
                {{ customer.name }}
              </span>
              <span>
                CPF/CNPJ: {{ customer.document | formatClientDocument }}
              </span>
            </div>
          </div>
        </div>

        <div>
          <div
            class="flex items-center justify-between w-full"
            @click="toggleShowDelivery = !toggleShowDelivery"
          >
            <div
              class="flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6 text-purple-mobly"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clip-rule="evenodd"
                />
              </svg>

              <span
                class="text-lg font-semibold"
              >
                Endereço de entrega
              </span>
            </div>

            <div
              class="block md:hidden"
            >
              <svg
                v-if="!toggleShowDelivery"
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </div>
          </div>

          <div
            class="pl-4 md:grid"
            :class="toggleShowDelivery ? 'grid' : 'hidden'"
          >
            <p>
              {{ order.shipping.shippingAddress.street + ', ' + order.shipping.shippingAddress.street_number + getComplement(order.shipping.shippingAddress) }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.reference_point }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.neighborhood + ' - ' + order.shipping.shippingAddress.city_name + ' - ' + order.shipping.shippingAddress.state_name }}
            </p>
            <p>
              {{ order.shipping.shippingAddress.zipcode }}
            </p>
            <span>
              Telefone: {{ getContact(order.shipping) | formatPhone }}
            </span>
          </div>
        </div>

        <div>
          <div
            class="flex items-center justify-between w-full"
            @click="toggleShowPaymentData = !toggleShowPaymentData"
          >
            <div
              class="flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-6 h-6 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                />
              </svg>

              <span
                class="text-lg font-semibold"
              >
                Dados do pagamento
              </span>
            </div>

            <div
              class="block md:hidden"
            >
              <svg
                v-if="!toggleShowPaymentData"
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>

              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="w-5 h-5 text-purple-mobly"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </div>
          </div>

          <div>
            <div
              class="pl-4 md:grid"
              :class="toggleShowPaymentData ? 'grid' : 'hidden'"
            >
              <table>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Forma de Pagamento
                  </td>

                  <td>
                     {{ order.paymentMethod }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Subtotal {{ order.itemsCount > 1 ? `(${order.itemsCount } Itens)` : '(1 Item)' }}
                  </td>
                  <td>
                    {{ order.invoice.unit_amount | formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Descontos
                  </td>
                  <td>
                    -{{ order.invoice.discount_amount | formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Total de frete
                  </td>
                  <td>
                    {{ order.invoice.shipping_amount | formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Total de montagem
                  </td>
                  <td>
                    {{ order.invoice.assembly_amount | formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Vale Troca
                  </td>
                  <td>
                    {{ getExchange(order.invoice)| formatCurrency }}
                  </td>
                </tr>
                <tr>
                  <td
                    class="pr-2"
                  >
                    Valor Total do pedido
                  </td>
                  <td
                    class="font-semibold"
                  >
                    {{ getTotalOrder(order.payments)| formatCurrency }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="showActions()"
        id="show-buttons-actions"
        class="py-2 border-t-2"
      >
        <span
          class="text-xl text-gray-800"
        >
          Precisa de ajuda sobre este pedido?
        </span>

        <div
          class="grid flex-wrap items-center sm:flex sm:flex-row sm:flex-wrap sm:justify-start justify-items-stretch"
        >
          <button
            v-if="isBoleto(order) && showButtonBoleto()"
            @click="openBoleto(order)"
            class="flex items-center justify-center px-2 py-2 mt-3 mr-3 space-x-2 font-semibold rounded h-max text-md border-1 hover:text-purple-mobly-dark border-purple-mobly text-purple-mobly focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>

            <span
              class="whitespace-nowrap"
            >
              Baixar boleto
            </span>
          </button>

          <button
            v-if="showButtonHelpPayments()"
            id="button-help-payments"
            class="flex items-center justify-center px-2 py-2 mt-3 mr-3 space-x-2 font-semibold rounded h-max text-md border-1 hover:text-purple-mobly-dark border-purple-mobly text-purple-mobly focus:outline-none"
            @click="showModalHelpPayments = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              />
            </svg>

            <span
              class="whitespace-nowrap"
            >
              Ajuda sobre o pagamento
            </span>
          </button>

          <button
            class="flex items-center justify-center px-2 py-2 mt-3 mr-3 space-x-2 font-semibold rounded h-max text-md border-1 hover:text-purple-mobly-dark border-purple-mobly text-purple-mobly focus:outline-none"
            @click="showModalChangeOrder = true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              />
            </svg>

            <span
              class="whitespace-nowrap"
            >
              É possível alterar o pedido?
            </span>
          </button>
        </div>
      </div>
    </div>

    <Modal
      id="modal-help-payments"
      :show="showModalHelpPayments"
    >
      <div
        slot="content"
        class=""
      >
        <div
          id="header"
          class="flex items-center justify-between px-3 py-2 text-white border-0 rounded bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            Ajuda sobre o pagamento
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="showModalHelpPayments = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div
          class="grid items-center justify-center px-3 py-10 space-y-2 text-lg justify-items-center"
        >
          <span
            class="text-center"
          >
            {{ orderLabels[orderStatus].paymentHelpMessage }}
          </span>

          <button
            class="text-white flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-purple-mobly hover:bg-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="openSelfService(order.orderNr)"
          >
            Abrir atendimento
          </button>

          <button
            class="text-purple-mobly flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-white hover:border-purple-mobly-dark hover:text-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="showModalHelpPayments = false"
          >
            Voltar
          </button>
        </div>
      </div>
    </Modal>

    <Modal
      id="modal-change-order"
      :show="showModalChangeOrder"
    >
      <div
        slot="content"
      >
        <div
          id="header"
          class="flex items-center justify-between w-full px-3 py-2 text-white border-0 rounded bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            É possível alterar o pedido?
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="showModalChangeOrder = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div
          class="grid items-center justify-center px-3 py-10 space-y-2 text-lg justify-items-center"
        >
          <span
            class="text-center"
          >
            Os dados de compra não podem ser alterados. Para realizar um novo pedido, cancele os itens desejados.
          </span>

          <button
            class="text-purple-mobly flex justify-center items-center space-x-2 font-semibold py-1.5 px-2 flex-nowrap border-1 border-purple-mobly rounded-md min-w-50 bg-white hover:border-purple-mobly-dark hover:text-purple-mobly-dark transition-colors focus:outline-none focus:ring-0 relative"
            @click="showModalChangeOrder = false"
          >
            Voltar
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { AsYouType } from 'libphonenumber-js'
import {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  CANCELED,
  FINISHED
} from '@/enum/enum.cluster.status'
import { formatDocument, currencyFormat } from '@/functions'
import Modal from '@/components/Commons/Modal'

export default {
  name: 'OrderHeader',

  props: {
    order: {
      type: Object,
      require: true
    }
  },

  components: {
    Modal
  },

  filters: {
    formatClientDocument: value => formatDocument(value),
    formatCurrency: value => currencyFormat(value),
    formatPhone: value => !value ? '--' : new AsYouType('BR').input(value)
  },

  data () {
    return {
      customer: {},
      toggleShowClientData: false,
      toggleShowDelivery: false,
      toggleShowPaymentData: false,
      showModalHelpPayments: false,
      showModalChangeOrder: false,
      orderStatus: 'default',
      statusShowActions: [
        'paymentPending',
        'paymentNoAprove',
        'orderInProgress'
      ],
      statusShowButtonBoleto: [
        'paymentPending',
        'paymentNoAprove'
      ],
      statusShowButtonPayment: [
        'paymentPending',
        'paymentNoAprove'
      ],
      orderLabels: {
        paymentPending: {
          title: 'Seu pedido está em análise de pagamento',
          textColor: 'text-blue-500',
          paymentHelpMessage: 'O pagamento ainda não foi aprovado. Gostaria de abrir um atendimento?'
        },
        paymentNoAprove: {
          title: 'Seu pagamento não foi aprovado :(',
          textColor: 'text-red-500',
          paymentHelpMessage: 'Infelizmente, o pagamento não foi aprovado. Gostaria de abrir um atendimento?'
        },
        orderInProgress: {
          title: 'Seu pedido está em andamento',
          textColor: 'text-green-500'
        },
        orderFinish: {
          title: 'Suas Compras',
          textColor: 'text-gray-600'
        },
        orderCanceled: {
          title: 'Seu pedido foi cancelado',
          textColor: 'text-red-500'
        },
        default: {
          title: '--',
          textColor: 'text-gray-600'
        }
      }
    }
  },

  mounted () {
    this.orderStatus = this.getOrderStatus(this.order.products)
    this.customer = this.getCustomer(this.order)
  },

  methods: {
    getCustomer (order) {
      if (!order || !order.products[0]) return {}

      const customer = order.products[0].customer

      return customer
    },

    isBoleto (order) {
      return order != null && order.boleto != null
    },

    showActions () {
      const isCurrentStatusValid = this.statusShowActions.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    showButtonBoleto () {
      const isCurrentStatusValid = this.statusShowButtonBoleto.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    showButtonHelpPayments () {
      const isCurrentStatusValid = this.statusShowButtonPayment.includes(this.orderStatus)

      return isCurrentStatusValid
    },

    getTotalOrder (payments) {
      return payments.reduce((acc, payment) => acc + payment.amount, 0)
    },

    getExchange (invoice) {
      const exchangeInProduct = invoice.discounts.find(discount =>
        discount && discount.type && discount.type.cod === 'EXCHANGE_COUPON_APPLIED_IN_PRODUCT'
      )

      if (!exchangeInProduct) return 0

      const exchangeInShipping = invoice.discounts.find(discount =>
        discount && discount.type && discount.type.cod === 'EXCHANGE_COUPON_APPLIED_IN_SHIPPING'
      )

      return exchangeInProduct.applied_amount + exchangeInShipping.applied_amount
    },

    getContact (shipping) {
      if (!shipping.contact_details) return

      const contact = shipping.contact_details.phones.find(phone => phone.type.cod === 'PRIMARY')

      return contact.phone_number
    },

    openBoleto (order) {
      if (!order.boleto) return false

      window.open(order.boleto, '_blank')
    },

    openSelfService (orderNumber) {
      const url = 'https://origin-api.mobly.com.br/cs-external/redirect-self-service?order=' + orderNumber

      window.open(url, '_blank')
    },

    getOrderStatus (items) {
      const itemsStatus = this.getItemsStatusClusters(items)

      if (itemsStatus.find(status => status.cluster === PAYMENT_PENDING && status.code !== 'CONFIRMED')) return 'paymentPending'

      if (itemsStatus.find(status => status.cluster === PAYMENT_NOT_APPROVED)) return 'paymentNoAprove'

      if (itemsStatus.find(status => status.cluster === PAYMENT_REPROVED)) return 'paymentNoAprove'

      if (itemsStatus.find(status => status.cluster === CANCELED)) return 'orderCanceled'

      if (itemsStatus.every(status => status.cluster === FINISHED)) return 'orderFinish'

      return 'orderInProgress'
    },

    getItemsStatusClusters (items) {
      return items.map(item => ({ cluster: item.lastStatus.cluster.toUpperCase(), code: item.lastStatus.code.cod }))
    },

    getComplement (address) {
      return address.complement ? ', ' + address.complement : ''
    }
  }
}
</script>
